import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';
import AuthStorage from '~/Utils/AuthStorage';
import VendaGravada from '~/Components/Vendas/VendaGravada';
import { CondicoesEspeciaisStatus } from '~/constant';
import {
  simulatorStateToVendaPayload,
  validarPayloadAntesSubmit,
} from '../payload';
import { formatCurrency } from '../utils';
import AdminCampos from './AdminCampos';
import Autorizacao from './Autorizacao';

function chaveErroValidacao(erro) {
  return 'erro-validacao-' + String(erro || '').replace(/[^a-zA-Z0-9]+/g, '-').slice(0, 80);
}

function pickCampo(obj, chaves, fallback) {
  if (!obj) return fallback;
  for (var i = 0; i < chaves.length; i++) {
    if (obj[chaves[i]] !== undefined && obj[chaves[i]] !== null) return obj[chaves[i]];
  }
  return fallback;
}

// Modal de geração de venda. Fluxo:
// 1. Busca + seleção de prospecto (consultarProspectos com detalha_vinculos)
// 2. Autorização (só quando há CE aplicada)
// 3. Dados da Venda (AdminCampos: construtor, PDV, venda interna, contrato digital,
//    tipo de boleto)
// 4. Submit + tela de sucesso (VendaGravada com link da PreVendaPropostaRapida.aspx)
// Divisão de Comissão e Parcelas Não Concomitantes vivem no fluxo da simulação
// (não no modal) — chegam via simulatorState e são enviados no payload.
export default function ModalGerarVenda(props) {
  var show = props.show;
  var onCancel = props.onCancel;
  // Disparado quando o user fecha o modal DEPOIS de uma venda gravada — reseta o
  // simulador pra etapa inicial (selecionar empreendimento).
  var onVendaGravadaFechar = props.onVendaGravadaFechar;
  var contextoSelecao = props.contextoSelecao || {}; // codigoFamilia, empreendimentoLabel, quadra, lote
  var simulatorState = props.simulatorState || {};
  var cartoes = props.cartoes || [];
  // Permissão de corretor (W-0075): corretor logado auto-seleciona; ADM+673 escolhe;
  // outros não enxergam o select e não conseguem gerar venda.
  var corretorAtivo = props.corretorAtivo || null;
  var setCorretorAtivo = props.setCorretorAtivo || function() {};
  var opcoesCorretores = props.opcoesCorretores || [];
  var modoCorretor = props.modoCorretor || 'oculto';
  var podeGerarVenda = props.podeGerarVenda === true;
  var codigoProposta = props.codigoProposta || null;
  var operacaoProposta = props.operacaoProposta || 'gravar';
  var contextoProposta = props.contextoProposta || null;
  var propostaGravada = props.propostaGravada || null;
  var isModoProposta = !!codigoProposta;
  var labelsOperacao = {
    gravar: {
      titulo: 'Gerar Venda',
      principal: 'Gravar Venda',
      gravando: 'Gravando...',
      sucesso: 'Venda gravada com sucesso',
      sucessoTitulo: 'Venda Gravada',
    },
    aprovarProposta: {
      titulo: 'Analisar Solicitação',
      principal: 'Aprovar Solicitação',
      gravando: 'Aprovando...',
      sucesso: 'Solicitação aprovada com sucesso',
      sucessoTitulo: 'Solicitação Aprovada',
    },
    enviarContraproposta: {
      titulo: 'Enviar Contraproposta',
      principal: 'Enviar Contraproposta',
      gravando: 'Enviando...',
      sucesso: 'Contraproposta enviada com sucesso',
      sucessoTitulo: 'Contraproposta Enviada',
    },
    aprovarContraproposta: {
      titulo: 'Analisar Contraproposta',
      principal: 'Aprovar Contraproposta',
      gravando: 'Aprovando...',
      sucesso: 'Contraproposta aprovada com sucesso',
      sucessoTitulo: 'Contraproposta Aprovada',
    },
  };
  var labels = labelsOperacao[operacaoProposta] || labelsOperacao.gravar;

  var [termoBusca, setTermoBusca] = useState('');
  var [tipoFiltroBusca, setTipoFiltroBusca] = useState('nome');
  var [resultadosBusca, setResultadosBusca] = useState([]);
  var [buscando, setBuscando] = useState(false);
  var [prospectoSelecionado, setProspectoSelecionado] = useState(null);

  var [vinculoValidado, setVinculoValidado] = useState(false);
  var [erroVinculo, setErroVinculo] = useState(null);
  var [contextoVendaCarregado, setContextoVendaCarregado] = useState(null);

  var [autorizacao, setAutorizacao] = useState({
    justificativa: '', codigo_usuario: '', senha: '',
  });

  var [errosValidacao, setErrosValidacao] = useState([]);
  var [acaoEmAndamento, setAcaoEmAndamento] = useState(null);
  var [erroGravacao, setErroGravacao] = useState(null);
  var [vendaGravada, setVendaGravada] = useState(null);
  var gravando = !!acaoEmAndamento;
  var gravandoPrincipal = acaoEmAndamento === 'principal';
  var recusando = acaoEmAndamento === 'recusar';

  var [contratoDigital, setContratoDigital] = useState(false);
  var [vendaInterna, setVendaInterna] = useState(false);
  // opcao_recebimento_boletos: 1 = Físico e Digital (padrão), 3 = Somente Digital.
  const [opcaoRecebimentoBoletos, setOpcaoRecebimentoBoletos] = useState(1);

  const [codigoPdvSelecionado, setCodigoPdvSelecionado] = useState(null);
  const [codigoConstrutor, setCodigoConstrutor] = useState(null);
  const [chequeBonusDisponivel, setChequeBonusDisponivel] = useState(null);
  const [aplicouChequeBonusSinal, setAplicouChequeBonusSinal] = useState(false);

  var temCondicoes = !!simulatorState.condicoesAplicadas;
  var condicoesAutorizacao = simulatorState.condicoesAplicadas || null;
  var statusCondicoes = condicoesAutorizacao ? condicoesAutorizacao.status : null;
  var exigeAutorizacaoCondicoes = temCondicoes && statusCondicoes !== CondicoesEspeciaisStatus.SolicitacaoAprovada;
  // Sinal parcial também exige autorização (usuário + senha); sem credenciais a venda
  // vai para aprovação da diretoria. Diferente da condição especial, não exige justificativa.
  var sinalParcial = props.sinalParcial === true;
  var exigeAutorizacao = exigeAutorizacaoCondicoes || sinalParcial;
  var valorLoteAutorizacao = condicoesAutorizacao && condicoesAutorizacao.valorLote;
  var saldoCorrecaoAutorizacao = condicoesAutorizacao && condicoesAutorizacao.saldoCorrecao;
  var travarCondicaoAutorizacao = !!(condicoesAutorizacao && (
    condicoesAutorizacao.isIsencao
    || (saldoCorrecaoAutorizacao && saldoCorrecaoAutorizacao.isAtivo)
    || (condicoesAutorizacao.travarVenda && condicoesAutorizacao.travarVenda.travarGerente)
  ));
  // divisão de comissão e parcelas não concomitantes chegam prontos do fluxo da simulação
  var divisaoComissaoSim = simulatorState.divisaoComissao || { codigoUsuario: null, porcentagem: '' };
  var isParcelasNaoConcomitantes = !!simulatorState.isParcelasNaoConcomitantes;

  var resetarTudo = useCallback(function() {
    setTermoBusca('');
    setResultadosBusca([]);
    setProspectoSelecionado(null);
    setVinculoValidado(false);
    setErroVinculo(null);
    setContextoVendaCarregado(null);
    setErrosValidacao([]);
    setErroGravacao(null);
    setVendaGravada(null);
    setAcaoEmAndamento(null);
    setChequeBonusDisponivel(null);
    setAplicouChequeBonusSinal(false);
    setCodigoPdvSelecionado(null);
    setCodigoConstrutor(null);
    setVendaInterna(false);
    setContratoDigital(false);
    setOpcaoRecebimentoBoletos(1);
  }, []);

  useEffect(function() {
    if (!show || !isModoProposta || !contextoProposta) return;

    var empreendimentoProposta = contextoProposta.empreendimento || {};
    var prospectoProposta = contextoProposta.prospecto || {};
    setProspectoSelecionado(prospectoProposta);
    setErroVinculo(null);
    setContextoVendaCarregado({
      empreendimento: {
        codigo: contextoProposta.codigoFamilia,
        cartoes: cartoes,
        ativos: empreendimentoProposta.ativos || [],
        tipo_recebimento_comissao: simulatorState.dados ? simulatorState.dados.tipo_recebimento_comissao : 0,
      },
      prospecto: prospectoProposta,
      cartoes: cartoes,
    });
    setVinculoValidado(true);
    setChequeBonusDisponivel(
      pickCampo(empreendimentoProposta, ['cheque_bonus', 'chequeBonus'], null)
    );
    setCodigoPdvSelecionado(
      pickCampo(propostaGravada, ['codigo_ponto_venda', 'codigoPontoVenda'], null)
    );
    setCodigoConstrutor(
      pickCampo(propostaGravada, ['codigo_construtor', 'codigoConstrutor'], null)
    );
    setVendaInterna(!!pickCampo(propostaGravada, ['venda_interna', 'vendaInterna'], false));
    setContratoDigital(!!pickCampo(propostaGravada, ['contrato_digital', 'contratoDigital'], false));
    setOpcaoRecebimentoBoletos(
      pickCampo(propostaGravada, ['opcao_recebimento_boletos', 'opcaoRecebimentoBoletos'], 1) || 1
    );
  }, [show, isModoProposta, contextoProposta, propostaGravada, simulatorState.dados, cartoes]);

  var handleClose = useCallback(function() {
    if (gravando) return;
    // Se a venda já foi gravada, dispara o reset do simulador (volta pra
    // seleção de empreendimento). Senão, só fecha o modal mantendo a simulação.
    var jaGravou = !!vendaGravada;
    resetarTudo();
    if (jaGravou && onVendaGravadaFechar) {
      onVendaGravadaFechar();
    } else {
      onCancel();
    }
  }, [gravando, onCancel, resetarTudo, vendaGravada, onVendaGravadaFechar]);

  var handleBuscarProspecto = useCallback(function() {
    var entrada = (termoBusca || '').trim();
    if (entrada.length < 3) {
      toast.warn('Informe ao menos 3 caracteres');
      return;
    }
    // Para CPF/CNPJ/telefone/código, normaliza tirando máscara/letras
    var filtro = entrada;
    if (tipoFiltroBusca === 'cpf_cnpj' || tipoFiltroBusca === 'telefone' || tipoFiltroBusca === 'prospecto') {
      filtro = entrada.replace(/\D/g, '');
    }

    setBuscando(true);
    // Busca por nome com múltiplas palavras: envia a primeira ao backend (resultado amplo)
    // e filtra as demais no cliente — ex: "William santos" encontra "William Claudio dos Santos".
    var palavras = tipoFiltroBusca === 'nome'
      ? filtro.split(/\s+/).filter(Boolean)
      : null;
    var filtroPrincipal = (palavras && palavras.length > 1) ? palavras[0] : filtro;
    var palavrasExtras = (palavras && palavras.length > 1)
      ? palavras.slice(1).map(function(w) { return w.toLowerCase(); })
      : [];

    api.consultarProspectos({
      tipo_filtro: tipoFiltroBusca,
      filtro: filtroPrincipal,
      codigo_empreendimento: contextoSelecao.codigoFamilia || '',
      pagina_atual: 1,
      quantidade_por_consulta: 50,
      detalha_vinculos: true,
    })
      .then(function(res) {
        var lista = (res && res.prospectos) || (Array.isArray(res) ? res : []);
        if (palavrasExtras.length > 0) {
          lista = lista.filter(function(p) {
            var nome = (p.nome || '').toLowerCase();
            return palavrasExtras.every(function(w) { return nome.includes(w); });
          });
        }
        setResultadosBusca(lista);
        if (lista.length === 0) toast.info('Nenhum prospecto encontrado para "' + entrada + '"');
      })
      .catch(function(err) {
        toast.error('Erro ao buscar prospecto: ' + (err.message || ''));
      })
      .finally(function() { setBuscando(false); });
  }, [termoBusca, tipoFiltroBusca, contextoSelecao.codigoFamilia]);

  // Ao selecionar prospecto: detecta vínculo localmente via vinculos[] e
  // já popula contextoVendaCarregado (sem chamada API). Se não tem vínculo,
  // só seta um aviso — não bloqueia. O backend valida tudo no submit final.
  var handleSelecionarProspecto = useCallback(function(p) {
    setProspectoSelecionado(p);
    setErroVinculo(null);

    var temVinculo = (p.vinculos || []).some(function(v) {
      return String(v.codigo_familia) === String(contextoSelecao.codigoFamilia);
    });
    if (!temVinculo) {
      setErroVinculo('Atenção: este prospecto não aparece vinculado a ' +
        (contextoSelecao.empreendimentoLabel || contextoSelecao.codigoFamilia) +
        ' nos resultados. O backend pode rejeitar a gravação. Vincule em /prospectos antes se possível.');
    }

    setContextoVendaCarregado({
      empreendimento: {
        codigo: contextoSelecao.codigoFamilia,
        cartoes: cartoes,
        tipo_recebimento_comissao: simulatorState.dados ? simulatorState.dados.tipo_recebimento_comissao : 0,
      },
      prospecto: p,
      cartoes: cartoes,
    });
    setVinculoValidado(true);

    const idProspecto = p.codigo_descriptografado || p.codigo;
    // Best-effort: tenta carregar cheque_bonus pra exibir no modal. Sem reserva — a
    // reserva do lote acontece só ao clicar Gravar Venda (dentro de GravarVendas no back).
    if (contextoSelecao.codigoFamilia && idProspecto) {
      api.obterPropostaInicialSimulador(contextoSelecao.codigoFamilia, idProspecto)
        .then(res => {
          const bonus = res && res.empreendimento && res.empreendimento.cheque_bonus;
          setChequeBonusDisponivel(bonus ? bonus : null);
        })
        .catch(() => setChequeBonusDisponivel(null));
    }
  }, [contextoSelecao.codigoFamilia, contextoSelecao.empreendimentoLabel, cartoes, simulatorState.dados]);

  var handleGravar = useCallback(function() {
    if (!vinculoValidado || !contextoVendaCarregado) {
      toast.warn('Valide o vínculo do prospecto antes de gravar');
      return;
    }
    if (!podeGerarVenda) {
      toast.warn('Usuário sem permissão para executar esta ação');
      return;
    }

    if (isModoProposta && (operacaoProposta === 'aprovarProposta' || operacaoProposta === 'aprovarContraproposta')) {
      if (exigeAutorizacaoCondicoes && (!autorizacao.justificativa || autorizacao.justificativa.length < 5)) {
        toast.warn('Informe uma justificativa antes de aprovar');
        return;
      }
      setErrosValidacao([]);
      setAcaoEmAndamento('principal');
      setErroGravacao(null);
      api.autorizarVendaSimulador(codigoProposta, {
        justificativa: autorizacao.justificativa || '',
      })
        .then(function(res) {
          setVendaGravada(res);
          toast.success(labels.sucesso);
        })
        .catch(function(err) {
          var msg = (err && err.message) ? err.message : 'Falha ao aprovar';
          setErroGravacao(msg);
          toast.error('Erro ao aprovar: ' + msg);
        })
        .finally(function() { setAcaoEmAndamento(null); });
      return;
    }

    if (!corretorAtivo) {
      toast.warn('Selecione um corretor antes de gravar');
      return;
    }
    var fullState = Object.assign({}, simulatorState, {
      contextoVenda: contextoVendaCarregado,
      codigoCorretorAtivo: corretorAtivo,
      codigoProposta: codigoProposta,
      contraproposta: operacaoProposta === 'enviarContraproposta',
      codigoConstrutor: codigoConstrutor,
      codigoPontoVenda: codigoPdvSelecionado,
      vendaInterna: vendaInterna,
      contratoDigital: contratoDigital,
      aplicouChequeBonusSinal: aplicouChequeBonusSinal,
      divisaoComissao: divisaoComissaoSim && divisaoComissaoSim.codigoUsuario
        ? { codigo_usuario: divisaoComissaoSim.codigoUsuario, porcentagem: parseFloat(divisaoComissaoSim.porcentagem) || 0 }
        : null,
      opcaoRecebimentoBoletos: opcaoRecebimentoBoletos,
      isParcelasNaoConcomitantes: isParcelasNaoConcomitantes,
      autorizacao: exigeAutorizacao
        ? autorizacao
        : { justificativa: '', codigo_usuario: '', senha: '' },
      condicoesExtras: {
        avaliacaoBancaria: false,
        dataTerminoConstrucao: null,
        indiceCorrecao: null,
      },
    });
    var payload = simulatorStateToVendaPayload(fullState);
    var erros = validarPayloadAntesSubmit(payload, fullState);
    if (erros.length > 0) {
      setErrosValidacao(erros);
      return;
    }
    setErrosValidacao([]);
    setAcaoEmAndamento('principal');
    setErroGravacao(null);
    var idProspectoPath = contextoVendaCarregado.prospecto.codigo_descriptografado
      || contextoVendaCarregado.prospecto.codigo;
    // Usa endpoint paralelo do simulador (sem validação de GE do user da sessão)
    api.gravarVendaSimulador(
      contextoVendaCarregado.empreendimento.codigo,
      idProspectoPath,
      payload
    )
      .then(function(res) {
        setVendaGravada(res);
        toast.success(labels.sucesso);
      })
      .catch(function(err) {
        var msg = (err && err.message) ? err.message : 'Falha ao gravar';
        setErroGravacao(msg);
        toast.error('Erro ao gravar: ' + msg);
      })
      .finally(function() { setAcaoEmAndamento(null); });
  }, [
    vinculoValidado, contextoVendaCarregado, simulatorState,
    autorizacao, contratoDigital, vendaInterna,
    codigoConstrutor, codigoPdvSelecionado, aplicouChequeBonusSinal,
    opcaoRecebimentoBoletos, divisaoComissaoSim, isParcelasNaoConcomitantes,
    corretorAtivo, podeGerarVenda, isModoProposta, operacaoProposta, codigoProposta,
    labels, exigeAutorizacaoCondicoes, exigeAutorizacao,
  ]);

  var handleRecusarContraproposta = useCallback(function() {
    if (!codigoProposta || gravando) return;
    if (!podeGerarVenda) {
      toast.warn('Usuário sem permissão para executar esta ação');
      return;
    }
    setAcaoEmAndamento('recusar');
    setErroGravacao(null);
    api.excluirPropostaRapidaAuxiliar(codigoProposta)
      .then(function() {
        toast.success(
          operacaoProposta === 'aprovarContraproposta'
            ? 'Contraproposta recusada com sucesso'
            : 'Solicitação recusada com sucesso'
        );
        resetarTudo();
        onCancel();
      })
      .catch(function(err) {
        var msg = (err && err.message) ? err.message : 'Falha ao recusar solicitação';
        setErroGravacao(msg);
        toast.error('Erro ao recusar: ' + msg);
      })
      .finally(function() { setAcaoEmAndamento(null); });
  }, [codigoProposta, gravando, onCancel, operacaoProposta, podeGerarVenda, resetarTudo]);

  // Tela de sucesso —————————————————————————————————————————————
  if (vendaGravada) {
    return (
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title className="h6"><strong>{labels.sucessoTitulo}</strong></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <VendaGravada
            vendaGravada={vendaGravada}
            codigoProspecto={contextoVendaCarregado && contextoVendaCarregado.prospecto.codigo}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Fechar</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  var exigeCorretorPayload = !isModoProposta || operacaoProposta === 'enviarContraproposta';
  var exibeCamposAdministrativos = !isModoProposta || operacaoProposta === 'enviarContraproposta';
  var permiteRecusarProposta = isModoProposta
    && exigeAutorizacaoCondicoes
    && (operacaoProposta === 'aprovarProposta' || operacaoProposta === 'aprovarContraproposta');
  var textoRecusarProposta = operacaoProposta === 'aprovarContraproposta'
    ? 'Recusar Contraproposta'
    : 'Recusar Solicitação';
  var desabilitarPrincipal = gravando
    || !vinculoValidado
    || !podeGerarVenda
    || (exigeCorretorPayload && !corretorAtivo);

  return (
    <Modal show={show} onHide={handleClose} size="xl" centered scrollable>
      <Modal.Header closeButton={!gravando}>
        <Modal.Title className="h6">
          <strong>{labels.titulo}</strong>
          <span className="ml-2 text-muted small">
            {contextoSelecao.empreendimentoLabel} · Quadra {contextoSelecao.quadra} · Lote {contextoSelecao.lote}
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isModoProposta ? (
          <>
            {/* 1. Prospecto */}
            <h6 className="text-primary mb-2"><strong>1. Selecione o prospecto</strong></h6>
            <Row className="align-items-end mb-2">
              <Col md={3} xs={5}>
                <Form.Control
                  as="select"
                  size="sm"
                  value={tipoFiltroBusca}
                  disabled={buscando}
                  onChange={function(e) {
                    setTipoFiltroBusca(e.target.value);
                    setResultadosBusca([]);
                  }}
                >
                  <option value="nome">Nome</option>
                  <option value="cpf_cnpj">CPF/CNPJ</option>
                  <option value="rg_ie">RG/IE</option>
                  <option value="telefone">Telefone</option>
                  <option value="email">E-mail</option>
                  <option value="prospecto">Código do prospecto</option>
                </Form.Control>
              </Col>
              <Col md={6} xs={7}>
                <Form.Control
                  size="sm"
                  disabled={buscando}
                  placeholder={
                    tipoFiltroBusca === 'cpf_cnpj' ? 'Digite CPF/CNPJ (só números ou com máscara)...'
                      : tipoFiltroBusca === 'rg_ie' ? 'Digite RG ou Inscrição Estadual...'
                      : tipoFiltroBusca === 'telefone' ? 'Digite telefone com DDD...'
                      : tipoFiltroBusca === 'prospecto' ? 'Digite código do prospecto...'
                      : tipoFiltroBusca === 'email' ? 'Digite e-mail...'
                      : 'Digite nome (mín. 3 caracteres)...'
                  }
                  value={termoBusca}
                  onChange={function(e) { setTermoBusca(e.target.value); }}
                  onKeyDown={function(e) {
                    if (e.key === 'Enter' && !buscando) handleBuscarProspecto();
                  }}
                />
              </Col>
              <Col md={3} xs={12} className="mt-2 mt-md-0">
                <Button
                  size="sm"
                  variant="primary"
                  onClick={handleBuscarProspecto}
                  disabled={buscando}
                  className="w-100"
                >
                  {buscando ? (
                    <><Spinner animation="border" size="sm" className="mr-1" />Buscando...</>
                  ) : 'Buscar'}
                </Button>
              </Col>
            </Row>

            {resultadosBusca.length > 0 && (
              <div className="mb-2" style={{ maxHeight: 220, overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: 4 }}>
                {resultadosBusca.map(function(p) {
                  var pCodigo = p.codigo_descriptografado || p.codigo;
                  var isSel = prospectoSelecionado &&
                    (prospectoSelecionado.codigo_descriptografado || prospectoSelecionado.codigo) === pCodigo;
                  var temVinculo = (p.vinculos || []).some(function(v) {
                    return String(v.codigo_familia) === String(contextoSelecao.codigoFamilia);
                  });
                  return (
                    <div
                      key={pCodigo}
                      onClick={function() { handleSelecionarProspecto(p); }}
                      className={'p-2 small ' + (isSel ? 'bg-primary text-white' : '')}
                      style={{ cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}
                    >
                      <div>
                        <strong>{p.nome || '(sem nome)'}</strong>
                        {p.cpf_cnpj && <span> · CPF/CNPJ {p.cpf_cnpj}</span>}
                        {p.cpf && !p.cpf_cnpj && <span> · CPF {p.cpf}</span>}
                        <span className="ml-1">· #{pCodigo}</span>
                      </div>
                      <div className="mt-1">
                        {temVinculo ? (
                          <span className={'badge ' + (isSel ? 'badge-light' : 'badge-success')}>
                            ✓ Vinculado a este empreendimento
                          </span>
                        ) : (
                          <span className={'badge ' + (isSel ? 'badge-light' : 'badge-warning')}>
                            Sem vínculo com {contextoSelecao.empreendimentoLabel || 'este empreendimento'}
                          </span>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {prospectoSelecionado && (
              <div className="mb-3 p-2 rounded" style={{ background: '#f8f9fa', border: '1px solid #dee2e6' }}>
                <div className="small">
                  <strong>Prospecto selecionado:</strong>{' '}
                  {prospectoSelecionado.nome ||
                    prospectoSelecionado.codigo_descriptografado ||
                    prospectoSelecionado.codigo}
                  {(prospectoSelecionado.cpf_cnpj || prospectoSelecionado.cpf) && (
                    <span className="text-muted">
                      {' '}· CPF/CNPJ {prospectoSelecionado.cpf_cnpj || prospectoSelecionado.cpf}
                    </span>
                  )}
                </div>
                {erroVinculo && (
                  <Alert variant="warning" className="py-2 small mt-2 mb-0">
                    <FaExclamationTriangle className="mr-1" />
                    {erroVinculo}
                  </Alert>
                )}
              </div>
            )}
          </>
        ) : (
          <Alert variant="info" className="py-2 small mb-3">
            <strong>Proposta #{codigoProposta}</strong>
            {' '}· Prospecto {prospectoSelecionado && (prospectoSelecionado.codigo_descriptografado || prospectoSelecionado.codigo)}
          </Alert>
        )}

        {/* 2. Autorização + Opções — só após selecionar prospecto */}
        {vinculoValidado && (
          <>
            {/* Autorização só aparece quando há CE fora da alçada do corretor (espelha venda real:
                Checkout só mostra autorização quando listaMotivosAutorizacao > 0) */}
            {exigeAutorizacao && (
              <>
                <h6 className="text-primary mb-2 mt-3">
                  <strong>Autorização</strong>
                </h6>
                <Autorizacao
                  autorizacao={autorizacao}
                  setAutorizacao={setAutorizacao}
                  obrigatorio={exigeAutorizacaoCondicoes}
                  somenteJustificativa={isModoProposta}
                  avisoAlcada={condicoesAutorizacao && condicoesAutorizacao.avisoAlcada}
                  isCondicaoEspecial={!!(condicoesAutorizacao && condicoesAutorizacao.descricao)}
                  porcentagemDesconto={valorLoteAutorizacao ? valorLoteAutorizacao.porcentagem : 0}
                  codigoFamilia={contextoSelecao.codigoFamilia}
                  travarCondicao={travarCondicaoAutorizacao}
                />
              </>
            )}

            {exibeCamposAdministrativos && chequeBonusDisponivel && (
              <Alert variant="info" className="py-2 small mt-3 mb-2">
                <strong>Cheque Bônus disponível:</strong>{' '}
                R$ {formatCurrency(chequeBonusDisponivel.valor || 0)} — aplica sobre o sinal.
                <Form.Check
                  type="checkbox"
                  id="opcao-cheque-bonus"
                  label="Aplicar cheque bônus no sinal"
                  checked={aplicouChequeBonusSinal}
                  onChange={function(e) { setAplicouChequeBonusSinal(e.target.checked); }}
                  className="mt-1"
                />
              </Alert>
            )}

            {exibeCamposAdministrativos && (
              <div className="mt-3">
                <AdminCampos
                  codigoFamilia={contextoSelecao.codigoFamilia}
                  codigoConstrutor={codigoConstrutor}
                  setCodigoConstrutor={setCodigoConstrutor}
                  codigoPontoVenda={codigoPdvSelecionado}
                  setCodigoPontoVenda={setCodigoPdvSelecionado}
                  vendaInterna={vendaInterna}
                  setVendaInterna={setVendaInterna}
                  contratoDigital={contratoDigital}
                  setContratoDigital={setContratoDigital}
                  opcaoRecebimentoBoletos={opcaoRecebimentoBoletos}
                  setOpcaoRecebimentoBoletos={setOpcaoRecebimentoBoletos}
                  corretorAtivo={corretorAtivo}
                  setCorretorAtivo={setCorretorAtivo}
                  opcoesCorretores={opcoesCorretores}
                  modoCorretor={modoCorretor}
                />
              </div>
            )}
          </>
        )}

        {/* Erros */}
        {errosValidacao.length > 0 && (
          <Alert variant="danger" className="py-2 small mt-3">
            <strong>Corrija antes de gravar:</strong>
            <ul className="mb-0 mt-1">
              {errosValidacao.map(function(e) { return <li key={chaveErroValidacao(e)}>{e}</li>; })}
            </ul>
          </Alert>
        )}
        {erroGravacao && (
          <Alert variant="danger" className="py-2 small mt-3">
            <strong>Erro:</strong> {erroGravacao}
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={gravando}>
          Cancelar
        </Button>
        {permiteRecusarProposta && (
          <Button
            variant="outline-danger"
            onClick={handleRecusarContraproposta}
            disabled={gravando || !podeGerarVenda}
            title={!podeGerarVenda ? 'Usuário sem permissão para executar esta ação' : undefined}
          >
            {recusando ? (
              <><Spinner animation="border" size="sm" className="mr-1" />Recusando...</>
            ) : (
              textoRecusarProposta
            )}
          </Button>
        )}
        <Button
          variant={operacaoProposta === 'enviarContraproposta' ? 'warning' : 'success'}
          onClick={handleGravar}
          disabled={desabilitarPrincipal}
          title={
            !podeGerarVenda
              ? 'Usuário sem permissão para executar esta ação'
              : exigeCorretorPayload && !corretorAtivo
                ? 'Selecione um corretor antes de continuar'
                : undefined
          }
        >
          {gravandoPrincipal ? (
            <><Spinner animation="border" size="sm" className="mr-1" />{labels.gravando}</>
          ) : (
            <><FaCheckCircle className="mr-1" />{labels.principal}</>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
